// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { textColorPlugin } from '@atlaskit/editor-plugin-text-color';
export type {
	TextColorPlugin,
	TextColorPluginOptions,
	Dependencies,
	TextColorInputMethod,
	TextColorPluginState,
	TextColorPluginConfig,
} from '@atlaskit/editor-plugin-text-color';
